import React from 'react'
import bag from '../../assets/img/cart/bag.svg'
import check from '../../assets/img/cart/check.svg'
import textAlign from '../../assets/img/cart/text-align.svg'
import arrowCircleRight from '../../assets/img/developing/arrow-circle-right.svg'
import bagWhite from '../../assets/img/developing/bag.svg'
import Cookies from 'universal-cookie'
import api from '../../api/api'
import { withTranslation } from 'react-i18next'
import { Button, Modal, ModalHeader, ModalFooter, Input, Card, CardHeader, Spinner } from 'reactstrap'
import PropTypes from 'prop-types'
import CartItem from '../../components/Cart/CartItem.jsx'
import { processError } from '../../lib/lib'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class Cart extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            order: [],
            items: [],
            cost: 0,
            discount: 0,
            totalCost: 0,
            alert: { show: false, message: '' },
            promo: '',
            needItems: [],
            currency: '',
            purchasing: false,
            cartItemsLoaded: false,
            orderLoaded: false,
            dataLoaded: false,
        }
        this.onDelete = this.onDelete.bind(this)
        this.onAdd = this.onAdd.bind(this)
        this.catalogBuy = this.catalogBuy.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.addAllNeededItems = this.addAllNeededItems.bind(this)
    }

    addAllNeededItems() {
        this.setState({ cartItemsLoaded: false })
        const neededItems = this.state.needItems.map((item) => item.id)
        this.onAdd(neededItems)
    }

    getCartList(data) {
        return new Promise((resolve, reject) => {
            api.getCartList(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    onDelete(ids) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const items = this.state.items
        const order = this.state.order
        ids.forEach((id) => {
            items.forEach((item, index) => {
                if (item.id === id) items.splice(index, 1)
            })
            order.forEach((item, index) => {
                if (item.itemId === id) order.splice(index, 1)
            })
        })
        this.getCartList({ token, lang, order }).then(({ cartItems: { rows, cost, totalCost }, needItems }) => {
            cookies.set('order', order, { path: '/' })
            this.setState({ items: rows, order, cost, totalCost, needItems: needItems.rows })
        })
    }

    onAdd(ids) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        let order = this.state.order
        ids.forEach((id) => {
            order.push({ itemId: id })
        })
        cookies.set('order', order, { path: '/' })
        api.getCartList({ token, lang, order })
            .then(({ cartItems: { rows, cost, totalCost }, needItems }) => this.setState({ items: rows, order, cost, totalCost, needItems: needItems.rows, cartItemsLoaded: true }))
            .catch((e) => processError(e, this.props.history))
    }

    closeModal() {
        this.setState({ alert: { show: false, message: '' } })
    }

    redirectTo(link) {
        this.props.history.push(`/${link}`)
    }

    catalogBuy(e) {
        e.preventDefault()
        this.setState({ purchasing: true })
        const { t } = this.props
        try {
            const token = cookies.get('accessToken')
            const lang = this.props.i18n.language
            const order = this.state.order
            const catalogIds = this.state.order.map((item) => item.itemId)
            // const promo = this.state.promo
            if (catalogIds.length) {
                api.getCartLink({ token, lang, order }).then((res) => {
                    window.open(res.url, "_self")
                }).catch((e) => {
                    this.setState({ purchasing: false })
                    processError(e, this.props.history)
                })

                // api.catalogBuy({ token, catalogIds, promo })
                // .then((res) => {
                //     cookies.set('order', [], { path: '/' })
                //     this.setState({ purchasing: false })
                //     res.paymentUrl ? window.open(res.paymentUrl) : this.props.history.push('/study')
                // })
                // .catch((e) => {
                //     processError(e, this.props.history)
                //     this.setState({ alert: { show: true, message: t('cart-buy-error') } })
                // })
            } else {
                this.setState({ alert: { show: true, message: t('cart-empty') }, purchasing: false })
            }
        } catch (e) {
            this.setState({ purchasing: false })
        }
    }

    removeDuplicates(order, key) {
        return new Promise((resolve, reject) => {
            try {
                const filteredOrder = [...new Map(order.map((x) => [key(x), x])).values()]
                resolve(filteredOrder)
            } catch (e) {
                reject(e)
            }
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        let arrPromise = [
            this.removeDuplicates(cookies.get('order') || [], (item) => item.itemId).then((order) => {
                this.setState({ order, orderLoaded: true })
                cookies.set('order', order, { path: '/' })
                api.getCartList({ token, lang, order })
                    .then(({ cartItems: { rows, cost, totalCost }, needItems }) => {
                        const currencyRow = rows.find(({ currency }) => currency)
                        const currency = currencyRow ? currencyRow.currency : ""
                        this.setState({ items: rows, cost, totalCost, needItems: needItems.rows, currency, cartItemsLoaded: true })
                    })
                    .catch((e) => processError(e, this.props.history))
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <Modal isOpen={this.state.alert.show} toggle={this.closeModal} className={this.state.alert.show ? 'cart-modal' : 'd-none'}>
                    <ModalHeader toggle={this.closeModal} className="lg-font-size">{this.state.alert.message}</ModalHeader>
                    <ModalFooter>
                        <Button className="custom-card-btn primary btn btn-secondary m-0 sm-font-size" onClick={() => this.redirectTo('catalog')}>{t('cart-catalog-checkout')}</Button>
                    </ModalFooter>
                </Modal>
                <div className="content cart__content">
                    <div className="row">
                        <div className="col-xs-12 col-md-9">
                            <div className="routing">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="routing__inner d-flex align-items-center justify-content-start">
                                            <div className="basket d-flex align-items-center justify-content-start">
                                                <img src={bag} alt="bag" className="routing__img" />
                                                <span className="routing__name md-font-size active">{t('cart-cart')}</span>
                                            </div>
                                            <div className="data d-flex align-items-center justify-content-start">
                                                <img src={textAlign} alt="bag" className="routing__img" />
                                                <span className="routing__name md-font-size">{t('cart-data-input')}</span>
                                            </div>
                                            <div className="order d-flex align-items-center justify-content-start">
                                                <img src={check} alt="bag" className="routing__img" />
                                                <span className="routing__name md-font-size">{t('cart-checkout')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="basket section">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="section__title xl-font-size">{t('cart-cart')}</h4>
                                        <div className="order">
                                            {
                                                this.state.cartItemsLoaded ?
                                                    this.state.items.length ?
                                                        this.state.items.map((item) => (
                                                            <CartItem key={item.id}
                                                                id={item.id}
                                                                image={item.image}
                                                                title={item.title}
                                                                currency={item.currency}
                                                                desc={item.desc}
                                                                tags={item.tags || []}
                                                                totalPartners={item.totalPartners || 0}
                                                                partners={item.partners || []}
                                                                favorite={item.favorite}
                                                                likes={item.likes || 0}
                                                                oldPrice={item.oldPrice}
                                                                newPrice={item.newPrice}
                                                                add={false}
                                                                delete={true}
                                                                action={this.onDelete}
                                                                props={this.props}
                                                            />
                                                        )) :
                                                        <Card className="nostudy-card m-0">
                                                            <CardHeader className="lg-font-size">{t('cart-empty')}</CardHeader>
                                                        </Card>
                                                    :
                                                    <React.Fragment>
                                                        <CartItem skeleton={true} />
                                                    </React.Fragment>
                                            }
                                        </div>
                                    </div>
                                    {
                                        this.state.cartItemsLoaded ?
                                            this.state.needItems.length ?
                                                <div className="col-12">
                                                    <h4 className="section__title xl-font-size mt-5">{t('cart-need-items')}</h4>
                                                    <div className="order">
                                                        {
                                                            this.state.needItems.map((item) => (
                                                                <CartItem key={item.id}
                                                                    id={item.id}
                                                                    image={item.image}
                                                                    title={item.title}
                                                                    currency={item.currency}
                                                                    desc={item.desc}
                                                                    tags={item.tags || []}
                                                                    totalPartners={item.totalPartners || 0}
                                                                    partners={item.partners || []}
                                                                    favorite={item.favorite}
                                                                    likes={item.likes || 0}
                                                                    oldPrice={item.oldPrice}
                                                                    newPrice={item.newPrice}
                                                                    add={true}
                                                                    delete={false}
                                                                    action={this.onAdd}
                                                                    props={this.props}
                                                                />
                                                            ))
                                                        }
                                                    </div>
                                                    <Button disabled={!this.state.cartItemsLoaded} className="add-all-needed-items profile-avatar-btn primary" onClick={this.addAllNeededItems}>
                                                        {
                                                            !this.state.cartItemsLoaded ? <Spinner size="sm" /> : t('add-all-needed-items')
                                                        }
                                                    </Button>
                                                </div> : ''
                                            :
                                            <div className="col-12">
                                                <h4 className="section__title xl-font-size mt-5">{t('cart-need-items')}</h4>
                                                <div className="order">
                                                    <CartItem skeleton={true} />
                                                </div>
                                                <Skeleton button={true} className="add-all-needed-items profile-avatar-btn primary" />
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-3">
                            <div className="cart__sidebar">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="my-purchases">
                                            <h6 className="my-purchases__title lg-font-size">{t('cart-my-purchases')}</h6>
                                            <div className="my-purchases__item d-flex align-items-center justify-content-between">
                                                <p className="md-font-size">{t('cart-goods')}</p>
                                                <p className="md-font-size">{this.state.cartItemsLoaded ? this.state.items.length : <Skeleton width={50} />}</p>
                                            </div>
                                            <div className="my-purchases__item d-flex align-items-center justify-content-between">
                                                <p className="md-font-size">{t('cart-cost')}</p>
                                                <p className="md-font-size">{this.state.cartItemsLoaded ? `${this.state.cost} ${this.state.currency}` : <Skeleton width={50} />}</p>
                                            </div>
                                            <div className="my-purchases__item d-flex align-items-center justify-content-between">
                                                <p className="md-font-size">{t('cart-discount')}</p>
                                                <p className="md-font-size">{this.state.cartItemsLoaded ? this.state.discount : <Skeleton width={50} />}</p>
                                            </div>
                                            <div className="my-purchases__item d-flex align-items-center justify-content-between">
                                                {
                                                    this.state.cartItemsLoaded ?
                                                        <React.Fragment>
                                                            <Input
                                                                placeholder={t('cart-promocode')}
                                                                className="no__default__styles md-font-size"
                                                                onChange={(e) => this.setState({ promo: e.target.value })}
                                                            />
                                                            <img src={arrowCircleRight} alt="arrow" />
                                                        </React.Fragment>
                                                        :
                                                        <Skeleton height={30} width={200} className="d-block mx-auto" />
                                                }
                                            </div>
                                            <div className="my-purchases__item sum d-flex align-items-center justify-content-between">
                                                <p className="md-font-size">{t('cart-full-price')}</p>
                                                <p className="md-font-size">{this.state.cartItemsLoaded ? `${this.state.totalCost} ${this.state.currency}` : <Skeleton width={50} />}</p>
                                            </div>
                                            {
                                                this.state.cartItemsLoaded ?
                                                    <Button
                                                        className="card__btn my-purchases__btn d-flex align-items-center justify-content-center profile-avatar-btn primary btn-secondary"
                                                        disabled={!this.state.order.length}
                                                        onClick={this.catalogBuy}
                                                    >
                                                        {
                                                            this.state.purchasing ?
                                                                <Spinner
                                                                    as="span"
                                                                    animation="grow"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                /> :
                                                                <div>
                                                                    <img src={bagWhite} alt="bag" />
                                                                    <p className="sm-font-size">{t('cart-purchase')}</p>
                                                                </div>
                                                        }
                                                    </Button>
                                                    :
                                                    <Skeleton button={true} className="card__btn my-purchases__btn d-flex align-items-center justify-content-center profile-avatar-btn primary btn-secondary" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        )
    }
}

Cart.propTypes = {
    history: PropTypes.object,
    t: PropTypes.func,
    i18n: PropTypes.object,
}

export default withTranslation()(Cart)



// WEBPACK FOOTER //
// ./src/views/Cart/Cart.jsx